import { GlobalSearchCategorySchema } from "@redotech/redo-model/global-search/global-search-category";
import * as z from "zod/v4";
import { GlobalSearchItemSchema } from "./global-search-schema";

export const getGlobalSearchResults = {
  name: "getGlobalSearchResults" as const,
  input: z.object({
    category: GlobalSearchCategorySchema.optional(),
    searchText: z.string().optional(),
  }),
  output: z.object({ results: z.array(GlobalSearchItemSchema) }),
};
